// Import polyfill first to fix iOS Safari 14.4 URLSearchParams toString issues
import 'url-search-params-polyfill';

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import "./i18n";
import App from "./App.js";
import { initializeUrlToken } from "./utils/tokenManager.js";
import "./utils/versionManager.js";
import { initAmplitude, PLANNER_APP_AMPLITUDE_CONFIG } from "./utils/amplitude.js";

// Initialize URL token parsing before any other operations
// This ensures URL token takes priority over localStorage token
initializeUrlToken();

// Initialize Amplitude analytics (environment-aware)
// Note: This is async but we don't await it to avoid blocking app initialization
initAmplitude(PLANNER_APP_AMPLITUDE_CONFIG).catch((error) => {
  console.error('Failed to initialize Amplitude:', error);
});

// Initialize chunk error handler for handling 404s on missing assets

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element not found");
}

const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);
